import React, {useEffect, useContext} from 'react'
import XLSX from "xlsx";
import "./CSVUpload.css"  
// import _ from 'underscore';
import { useSelector, useDispatch } from "react-redux"
import { checkIfTermExists, resetCheckIfTermExistsDetailsState } from "../../redux/features/student/studentSlice"
import AppContext from '../../storage/AppContext';
import useToast from '../../shared/Toast';


function CSVUpload({setTableData,setColumns}) {
    
    const dispatch = useDispatch()

    const checkTermExistsDetails = useSelector(state => state.student.checkIfTermExistsDetails)
    const checkedData = checkTermExistsDetails.data
    const appContext = useContext(AppContext);
    const userDetails = appContext?.userDetails
    const showToast = useToast()

    useEffect(() => {
        if(checkTermExistsDetails.status === "succeeded"){
            setTableData(checkedData)
            dispatch(resetCheckIfTermExistsDetailsState())
        }else if(checkTermExistsDetails.status === "failed"){
            dispatch(resetCheckIfTermExistsDetailsState())
            showToast({ message: checkTermExistsDetails.error, type: 'error' })
        }
    },[checkTermExistsDetails])
    
    const handleFileChange = (event) => {
        setTableData([])
        const fileName = event.target.files[0].name.toLowerCase();
        if(fileName.endsWith(".csv") || fileName.endsWith(".xlsx")){
            const fileList = event.target.files;
            if (Object.keys(fileList).length === 0) return;
            const file = fileList[0];
            const reader = new FileReader();
            reader.onload = (e) => {
                const bstr = e.target.result;
                const workBook = XLSX.read(bstr, { type: "binary" });
                const workSheetName = workBook.SheetNames[0];
                const workSheet = workBook.Sheets[workSheetName];
                const fileData = XLSX.utils.sheet_to_json(workSheet, { header: 1 });

                const columns = fileData[0];
                const tableData = [];
                for (var i=1; i < fileData.length; i++) {
                    var obj = {}
                    for (var j = 0; j < columns.length; j++) {
                        columns[j] = columns[j].trim();
                        obj[columns[j]] = fileData[i][j];
                    }
                    tableData.push(obj);

                    // const emptyData = fileData[i].filter(item => !_.isEmpty(item))
                    // if(emptyData && emptyData.length > 0) {
                    // obj.id = i
                    // tableData.push(obj);
                    // }
                }
                const tableColumns = fileData[0].map(eachColumn => {
                    return {
                        Header: eachColumn,
                        accessor: eachColumn,
                    }
                })
                setColumns(tableColumns)
                dispatch(checkIfTermExists({tableData, branch:userDetails?.data?.branch}))
            };
            reader.readAsBinaryString(file);
            event.target.value = null;
        }else{
            alert("You have Uploaded a Invalid File")
        }
    };

  return (
    <div>
        <input
            className="inputfile"
            type="file"
            id="file"
            onChange={handleFileChange}
            accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        />
        <label htmlFor="file" className='m-0'>Upload CSV or EXCEL file</label>
    </div>
  )
}

export default CSVUpload